import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../../hook/use-http";
import NoData_Coral from "../NoData_Coral";
import ChartLoader_Coral from "../ChartLoader_Coral";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitialstates_coral";
import * as $ from "jquery";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register the required components from Chart.js
ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend
);

function MotorTempErc_Coral({ apiend, gloablfilter, title }) {
  const [maxData, setMaxData] = useState([]);
  const [medianData, setMedianData] = useState([]);
  const [labelLength, setLabelLength] = useState(0);
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const appyData = (data) => {
    setMaxData(data.max_temp);
    setMedianData(data.median_temp);
    setLabelLength(
      Array.from({ length: data.max_temp.length }, (_, i) => i + 1)
    );
  };

  const data = {
    labels: labelLength,
    datasets: [
      {
        label: "Median Motor temp",
        data: medianData, // Data for the first line
        fill: false,
        borderColor: "rgb(20, 148, 172)", // Line color
        tension: 0.1,
      },
      {
        label: "Max Motor temp",
        data: maxData, // Data for the second line
        fill: false,
        borderColor: "#ffa650", // Line color
        tension: 0.1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        position: "top", // Position of the legend
      },
      tooltip: {
        enabled: true, // Disable tooltip
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // Hide grid lines on X-axis
        },
        title: {
          display: true, // Display title for X-axis
          text: "Discharge Cycle", // Custom label for X-axis
          // color: '#000',  // Optional: Custom color for the label
          font: {
            size: 11, // Optional: Font size for the label
          },
        },
      },
      y: {
        grid: {
          display: false, // Hide grid lines on Y-axis
        },
        title: {
          display: true, // Display title for X-axis
          text: "Temperature", // Custom label for X-axis
          // color: '#000',  // Optional: Custom color for the label
          font: {
            size: 12, // Optional: Font size for the label
          },
        },
      },
    },
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + apiend,
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  return (
    <>
      <div className="v-title chartbox drive_graph p-0">
        <div className="titlebg titlebd_drive box_title pb-2 pt-2">{title}</div>
        <div className="chartHGT">
          {isLoading ? (
            <ChartLoader_Coral />
          ) : maxData.length === 0 ? (
            <NoData_Coral />
          ) : (
            <div className="ml-1 mb-1 mr-1" style={{ height: "235px" }}>
              <Line data={data} options={options} height={"198px"} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default MotorTempErc_Coral;
